export default function FacebookIcon() {
  return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="20" fill="white" fill-opacity="0.87"/>
<g clip-path="url(#clip0)">
<path d="M26.9244 21.7972L27.7229 16.5941H22.7304V13.2176C22.7304 11.7942 23.4278 10.4066 25.6638 10.4066H27.9334V5.97676C27.9334 5.97676 25.8738 5.62524 23.9045 5.62524C19.793 5.62524 17.1056 8.1173 17.1056 12.6286V16.5941H12.5353V21.7972H17.1056V34.3754H22.7304V21.7972H26.9244Z" fill="#333333"/>
</g>
<defs>
<clipPath id="clip0">
<rect width="17.9688" height="28.7501" fill="white" transform="translate(11.25 5.62524)"/>
</clipPath>
</defs>
</svg>

  );
}
